import React from 'react';
import { useCheckbox } from './index';
import * as styles from './styles.css';
import { Checkbox as MUICheckbox, FormControlLabel } from '@mui/material';
import BaseMultiSelect from '../multi-select/base-multi-select';
import { IOption } from '../../../interfaces';

export interface IOtherInputProps {
  id: string;
  label: string;
}

const OtherInput = ({ id, label }: IOtherInputProps) => {
  const { setValue } = useCheckbox(id);
  const [enable_other, setEnableOther] = React.useState(false);
  const [value, setInnerValue] = React.useState<IOption[]>([]);
  const onChange = (options: IOption[]) => {
    setInnerValue(options);
    const removed_values = options.filter((i) => value.every((v) => v.id !== i.id));
    const new_values = value.filter((i) => options.every((o) => o.id !== i.id));
    const changes = [...removed_values, ...new_values];
    changes.forEach((change) => setValue(change));
  };
  return (
    <div className={styles.other}>
      <FormControlLabel
        control={
          <MUICheckbox
            id={`${id}-other-checkbox`}
            checked={enable_other}
            onChange={() => setEnableOther(!enable_other)}
          />
        }
        label={'Other'}
      />
      <BaseMultiSelect
        id={`${id}-other-input`}
        placeholder={`${label} (Enter one by one and hit enter in between)`}
        value={value}
        freeSolo
        options={[]}
        onSelect={onChange}
        disabled={!enable_other}
      />
    </div>
  );
};

export default OtherInput;
